import React, { useEffect,useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import "./admindashboard.css"; // Import the updated CSS for dashboard styling
import axios from "axios";
import logo from './UNextLogo2.png';
const AdminDashboard = () => {

  
  const [email, setEmail] = useState(""); // User email input
  const [adminEmail, setAdminEmail] = useState(""); // Admin email display

  const [fromDate, setFromDate] = useState(""); // From date for date range
  const [toDate, setToDate] = useState(""); // To date for date range
  const [isDownloadingCSV, setIsDownloadingCSV] = useState(false);

   const location = useLocation();
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState("");
  const [isLoadingPDF, setIsLoadingPDF] = useState(false);
  useEffect(() => {
    // Retrieve admin email from localStorage
    const storedEmail = localStorage.getItem("email");
    if (storedEmail) {
      setAdminEmail(storedEmail);
    } else {
      // Redirect to login if no email is found
      navigate("/admin/login");
    }
  }, [navigate]);

  const handleLogout = () => {
    // Clear email from localStorage and redirect to login
    localStorage.removeItem("email");
    navigate("/admin/login");
  };


  const handleViewResults = async () => {
    setIsLoadingPDF(true); // Start loading
    setErrorMessage(""); // Clear any previous error messages
    try {
      const response = await axios.get(`/api/download-pdf?email=${encodeURIComponent(
          email
        )}`,
        { responseType: "blob" }
      );

      if (response.status === 404) {
        // Handle the case where the backend returns a 404 status (invalid email)
        const errorBlob = response.data;
        const errorJson = await errorBlob.text(); // Convert Blob to text
        const errorParsed = JSON.parse(errorJson); // Parse JSON string to object
  
        setErrorMessage(errorParsed.message); // Set error message from backend
        return; // Exit early to prevent PDF download
      }

      const pdfBlob = response.data;
      const pdfUrl = URL.createObjectURL(pdfBlob);

      //lets update the code here to download

      const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "survey-results.pdf"; // Name of the downloaded file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
      //window.open(pdfUrl, "_blank");
       // Navigate to LogoutPage
    //navigate("/logout", { replace: true });
    } catch (error) {
        console.log("Error response received:", error.response); // Debug log
        if (error.response && error.response.status === 404) {
            // Display error message if the email is invalid
            setErrorMessage("Invalid email");
      console.error("Error generating PDF:", error);
    }

else {
    console.error("Error generating PDF:", error);
    setErrorMessage("An error occurred while generating the PDF.");
  }

  }  finally
    {
      setIsLoadingPDF(false); // End loading
    }
  };
  const handleDownloadByDate = async () => {
    setIsDownloadingCSV(true); // Start downloading
    setErrorMessage(""); // Clear error messages
    try {
      const response = await axios.get(
        `/api/download-csv?fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}`,
        { responseType: "blob" }
      );

      if (response.status === 404) {
        setErrorMessage("No data found for the selected date range.");
        return;
      }

      const csvBlob = response.data;
      const csvUrl = URL.createObjectURL(csvBlob);

      const link = document.createElement("a");
      link.href = csvUrl;
      link.download = "responses-by-date.csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      setErrorMessage("An error occurred while downloading the CSV.");
    } finally {
      setIsDownloadingCSV(false); // End downloading
    }
  };
  return (


    
    <div className="admin-dashboard">
      
    <div className="admin-header">
    <span className="welcome-message">Welcome, {adminEmail}</span>
    <button onClick={handleLogout} className="logout-link">
  Logout
</button>
  </div>
     
        <div className="form-container">
        <img src={logo} alt="Logo" className="admindashboardlogo" />
        <div className="email-label">Email</div> {/* Add the Email label */}
          <form className="user-search-form">
            <input
              type="email"
              placeholder="Enter user email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="email-input"
              required
            />
            <button
              type="button"
              onClick={handleViewResults}
              className="view-results-btn"
            >
            {isLoadingPDF ? "Generating PDF..." : "View Results"}
            
            </button>
          </form>


          <div class="date-range-form">
          <div class="date-range-inputs">
            <label>
            From&nbsp;
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="date-input"
              />
            </label>
            <label>
              To
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                className="date-input"
              />
            </label>
          </div>
          <button
            type="button"
            onClick={handleDownloadByDate}
            className="download-csv-btn"
          >
            {isDownloadingCSV ? "Downloading CSV..." : "Download Report"}
          </button>
        </div>

          {errorMessage && <div className="adminerror-message">{errorMessage}</div>}
        </div>
</div>
        
  );
};

export default AdminDashboard;
